import React from "react";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useOutletContext, useNavigate } from "react-router-dom";
import LeaderboardSecton from "../components/Other/LeaderboardSecton";
import NewTraderGuide from "../components/guide/NewTraderGuide";
import { useNewTraderGuide } from "../context/NewTraderGuideContext";

const LeaderBoardPage = () => {

  const [sidebarToggle] = useOutletContext();
  const { guideActive, guideStep } = useNewTraderGuide();
  const persona = localStorage.getItem("qushi_onboarding_persona");

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <LeaderboardSecton />
      {guideActive && guideStep === 2 && persona === "experienced" && (
        <NewTraderGuide step={2} />
      )}
      {guideActive && guideStep === 3 && persona === "creator" && (
        <NewTraderGuide step={3} />
      )}
    </>
  );
};

export default LeaderBoardPage;
